import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from '@mui/icons-material/Add';
import { NOTIFICATION_TYPE } from "../../api/types/notification.types";
import React from "react";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [type, setType] = React.useState<number | 'default'>('default');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleTypeChange = (event: SelectChangeEvent<number | 'default'>) => {
    setType(event.target.value as number);
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification & Communication Center</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Notification & Communication Center
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              value={searchTerm}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
              onCross={() => setSearchTerm("")}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value={NOTIFICATION_TYPE.BROADCAST}>Broadcast</MenuItem>
                  <MenuItem value={NOTIFICATION_TYPE.MAIL}>Email</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-notifications/add")}><AddIcon /> Add Notification</Button>
          </div>
        </div>

        <NotificationsList
          searchTerm={debouncedSearchTerm}
          typeFilter={type}
        />
      </div>
    </>
  );
};

export default ManageNotifications;
